import React from 'react';

interface CardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  children: React.ReactNode;
  className?: string;
  title?: string | React.ReactNode;
  variant?: 'default' | 'elevated' | 'outlined' | 'interactive';
}

const variantStyles: Record<string, string> = {
  default: 'bg-surface border border-border shadow-sm',
  elevated: 'bg-surface border border-border shadow-md',
  outlined: 'bg-transparent border border-border',
  interactive: 'bg-surface border border-border shadow-sm hover:border-primary-500/30 hover:shadow-glow-blue cursor-pointer transition-all duration-200',
};

const Card: React.FC<CardProps> = ({ children, className = '', title, variant = 'default', ...props }) => {
  return (
    <div
      className={`rounded-lg p-5 ${variantStyles[variant]} ${className}`}
      {...props}
    >
      {title && <h3 className="text-lg font-semibold text-text-primary mb-4">{title}</h3>}
      {children}
    </div>
  );
};

export default Card;